// Type-safe suggestion data interfaces
export interface ContestantSuggestionData {
  name?: string;
  shortName?: string;
  imageUrl?: string;
}

export interface MemberSuggestionData {
  name?: string;
  number?: string;
  photoUrl?: string;
}

export interface DomainShortcutSuggestionData {
  domainShortcut?: boolean;
  domainShortcutValue?: string;
}

export interface SportSuggestionData {
  sport?: string;
}

// Type guards for suggestion data
export const isContestantData = (data: unknown): data is ContestantSuggestionData =>
  typeof data === 'object' && data !== null && ('name' in data || 'shortName' in data);

export const isMemberData = (data: unknown): data is MemberSuggestionData =>
  typeof data === 'object' && data !== null && 'name' in data;

export const isDomainShortcutData = (data: unknown): data is DomainShortcutSuggestionData =>
  typeof data === 'object' &&
  data !== null &&
  'domainShortcut' in data &&
  'domainShortcutValue' in data;

export const isSportData = (data: unknown): data is SportSuggestionData =>
  typeof data === 'object' && data !== null && 'sport' in data;
